import { motion, useReducedMotion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="qn-portada" data-testid="qn-portada">
      {datos.portadaVideo?.urlYoutube ? (
        <FondoVideoAmbient
          urlYoutube={datos.portadaVideo.urlYoutube}
          poster={datos.portadaVideo.poster || fotos.portada}
        />
      ) : (
        <img
          className="qn-portada-foto"
          src={fotos.portada}
          alt={`Fotografía de ${protagonista.nombre}`}
        />
      )}
      <div className="qn-portada-velo" />
      {protagonista.insignia && (
        <span className="qn-portada-insignia" aria-hidden="true">
          {protagonista.insignia}
        </span>
      )}
      <div className="qn-portada-contenido">
        <motion.p className="qn-portada-frase" {...entrar(0.15)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <motion.h1 className="qn-portada-nombre" data-testid="qn-nombre" {...entrar(0.35)}>
          {protagonista.nombre}
        </motion.h1>
        <motion.p className="qn-portada-fecha" data-testid="qn-fecha" {...entrar(0.55)}>
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p className="qn-portada-mensaje" {...entrar(0.7)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a href="#qn-contenido" className="qn-boton" data-testid="qn-boton-bajar" {...entrar(0.85)}>
            {protagonista.textoBotonEntrada}
          </motion.a>
        )}
      </div>
      <motion.span
        className="qn-portada-bajar"
        aria-hidden="true"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
      >
        <ChevronDown size={18} strokeWidth={1.5} />
      </motion.span>
    </header>
  );
}
